var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYourProducts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_your_product",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35233",
    "data-name": "Group 35233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35231",
    "data-name": "Group 35231"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pexels-moose-photos-1037999",
    width: 48,
    height: 48,
    rx: 15,
    fill: "rgba(100,87,232,0.1)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.5,0,0,5.75,11.5,11.5,23,5.75,11.5,0Z",
    fill: "none",
    stroke: "#ababf0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,0,11.5,5.75,23,0",
    transform: "translate(0 17.25)",
    fill: "none",
    stroke: "#ababf0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M0,0,11.5,5.75,23,0",
    transform: "translate(0 11.5)",
    fill: "none",
    stroke: "#ababf0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYourProducts);
export default __webpack_public_path__ + "static/media/icon-your-products.f5d31ad46477b920307eec04c799b842.svg";
export { ForwardRef as ReactComponent };